import React, { useContext } from 'react';
import { IEditGameContext, EditGameContext } from '../../../../editGameState/editGameContext';
import { TranslationForm } from 'components/TranslationForm/TranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		IDsSelectedLanguages,
		translations,
		selectedTranslationTab,
		fetchedLanguages,
	} = useContext<IEditGameContext>(EditGameContext);
	return (
		<TranslationForm
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			changeDescriptionTranslation={changeDescriptionTranslation}
			isVisible={isVisible}
			IDsSelectedLanguages={IDsSelectedLanguages}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
			fetchedLanguages={fetchedLanguages}
		/>
	);
};

export default TranslationsForm;
